import { Configuration } from 'api/base/configuration'

import { env } from 'env/index'

export const configuration: Configuration = {
  basePath: env.apiUrl,
}
